import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subject } from 'rxjs';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { ReportGroup } from 'src/app/_models/reports';
import { ConfigurationService } from 'src/app/_services/configuration.service';
import { PortalApiService } from '../../_services/portal-api.service';
import * as _ from 'lodash';
import { ReportFilters } from '../../_models/preferences';
import { ReportFilterService } from '../_services/report-filter.service';
import { PreferencesService } from '../_services/preferences.service';

@Component({
  selector: 'app-dashboard-list',
  templateUrl: './dashboard-list.component.html',
  styleUrls: ['./dashboard-list.component.css', '../report-list/report-list.component.css']
})
export class DashboardListComponent implements OnInit, OnDestroy {
  availableDashboards: ReportGroup[] = [];
  isLoading: boolean = false;
  errorRetrievingDashboards: boolean = false;
  noDashboardsReceived: boolean = false;
  noFavoriteDashboards: boolean = false;
  errorMessage: string = "";
  showFavoriteError: boolean = false;
  favoriteErrorMessage: string = "";
  queryString: string = "";
  showDashboards: boolean = false;
  interval: any;
  filters: ReportFilters = new ReportFilters;
  groupView: string = 'all';
  listDisplay: boolean = false;
  sortColumn?: string = null;
  sortDesc?: boolean = false;
  paginatePerPage: number = 24;
  p1: number = 1;
  dashboardsSort = {
    reportName: false
  };

  // Subjects
  private onDestroy$ = new Subject<void>();

  constructor(
    private titleService: Title,
    private configurationService: ConfigurationService,
    private router: Router,
    private apiService: PortalApiService,
    private cdr: ChangeDetectorRef,
    private reportFilterService: ReportFilterService,
    private route: ActivatedRoute,
    private preferencesService: PreferencesService
  ) {
    this.configurationService.configData$.subscribe(res => {
      this.showDashboards = res.showDashboards;
    });
  }

  ngOnInit(): void {
    this.titleService.setTitle('Dashboard List - Productioneer Portal');
    this.loadDashboardList();

    this.interval = setInterval(() => {
      /*  Reload page after 24 hrs due to expired token */
      this.refreshData();
    }, (86400000));

    this.filters = this.reportFilterService.resetFilters();

    const queryParams = this.route.snapshot.queryParams;
    Object.keys(queryParams).forEach(param => {
      switch (param) {
        case 'view':
          this.groupView = queryParams[param];
          break;
        case 'listDisplay':
          const displayListStyle = queryParams[param];
          if (displayListStyle == "false") {
            this.swapViews(false);
          } else {
            this.swapViews(true);
          }
          break;
        default:
          break;
      }
    });
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  loadDashboardList() {
    this.isLoading = true;
    this.apiService.getDashboards().subscribe({
      next: (data: ReportGroup[]) => {
        if (data.length == 0) {
          this.noDashboardsReceived = true;
        }
        else {
          data.map((dashGroup: ReportGroup) => {
            for (var i = 0; i < dashGroup.reports.length; i++) {
              dashGroup.reports[i].favTogglePending = false;
              dashGroup.reports[i].reportGroup = dashGroup.reportGroup;
              dashGroup.reports[i].reportGroupID = dashGroup.reportGroupID;
            }
          });
          this.availableDashboards = data;
        }
        this.isLoading = false;
      },
      error: err => {
        this.errorMessage = err.message;
        this.errorRetrievingDashboards = true;
        this.isLoading = false;
      }
    });
  }

  private refreshData() {
    window.location.reload();
  }

  updateQueryParams(paramName: string, paramValue: any) {
    const updatedParam: Params = {};
    updatedParam[paramName] = paramValue;
    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: updatedParam,
        queryParamsHandling: 'merge'
      }
    );
  }

  changeGroupView(viewName: string) {
    this.groupView = viewName;
    this.updateQueryParams('view', viewName);
  }

  swapViews(displayListStyle: boolean) {
    this.listDisplay = displayListStyle;
    this.preferencesService.updateCardDisplay(this.listDisplay);
    this.updateQueryParams('listDisplay', displayListStyle);
  }

  sortReportsBy(column: string | any) {
    this.dashboardsSort[column] = !this.dashboardsSort[column];
    this.sortColumn = column;
    this.sortDesc = this.dashboardsSort[column];
  }
}
